import lang from '@/lang' // Internationalization

/**
 * 根据键名获取相应的国际化值
 * @param lang 国际化对象
 * @param key 如果有值则返回key对应的值，如果为空则返回含有所有键值的大对象
 */
export const constantI18n = (lang, key) => {
  const data = {
    // 客户类型(ALL)
    companyTypeAll: [
      { label: lang.t('parameter.partnerServiceItem.ALL'), value: '' },
      { label: lang.t('parameter.partnerServiceItem.CUSTOMER'), value: 'CUSTOMER' },
      { label: lang.t('parameter.partnerServiceItem.BOOKING_AGENT'), value: 'BOOKING_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.OVERSEA_AGENT'), value: 'OVERSEA_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.DESIGNATION_AGENT'), value: 'DESIGNATION_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.LOCAL'), value: 'LOCAL' },
      { label: lang.t('parameter.partnerServiceItem.SETTLEMENT_AGENT'), value: 'SETTLEMENT_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.SEA_CMP'), value: 'SEA_CMP' },
      { label: lang.t('parameter.partnerServiceItem.AIR_CMP'), value: 'AIR_CMP' },
      { label: lang.t('parameter.partnerServiceItem.SEA_CMP_AGENT'), value: 'SEA_CMP_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.CUSTOMS_BROKER'), value: 'CUSTOMS_BROKER' },
      { label: lang.t('parameter.partnerServiceItem.TRUCK_CMP'), value: 'TRUCK_CMP' },
      { label: lang.t('parameter.partnerServiceItem.WAREHOUSE'), value: 'WAREHOUSE' },
      { label: lang.t('parameter.partnerServiceItem.GLOBAL'), value: 'GLOBAL' },
      { label: lang.t('parameter.partnerServiceItem.SHIPPER'), value: 'SHIPPER' },
      { label: lang.t('parameter.partnerServiceItem.CONSIGNEE'), value: 'CONSIGNEE' },
      { label: lang.t('parameter.partnerServiceItem.NOTIFY'), value: 'NOTIFY' },
      { label: lang.t('parameter.partnerServiceItem.PORT_AGENT'), value: 'PORT_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.FORWARDING_AGENT'), value: 'FORWARDING_AGENT' },
      { label: lang.t('parameter.partnerServiceItem.LOADINGPLACE_COMPANY'), value: 'LOADINGPLACE_COMPANY' },
      { label: lang.t('parameter.partnerServiceItem.SIGNBILLPLACE_COMPANY'), value: 'SIGNBILLPLACE_COMPANY' },
      { label: lang.t('parameter.partnerServiceItem.DISCHARGEPORT_COMPANY'), value: 'DISCHARGEPORT_COMPANY' },
      { label: lang.t('parameter.partnerServiceItem.DESTINATIONPORT_COMPANY'), value: 'DESTINATIONPORT_COMPANY' },
      { label: lang.t('parameter.partnerServiceItem.OTHER'), value: 'OTHER' }
    ],
    // 角色类型
    roleTypes: [
      { label: lang.t('parameter.roleType.SALES_TYPE'), value: 2 },
      { label: lang.t('parameter.roleType.CSR_TYPE'), value: 3 },
      { label: lang.t('parameter.roleType.DOC_TYPE'), value: 4 },
      { label: lang.t('parameter.roleType.OVERSEAOP_TYPE'), value: 5 },
      { label: lang.t('parameter.roleType.SALES_OF_GOODS'), value: 6 }
    ],
    // 签约状态
    contractStatuses: [
      { label: lang.t('constant.seaExportConstants.CONTRACT_STATE_NO'), value: 0 },
      { label: lang.t('constant.seaExportConstants.CONTRACT_STATE_OUT_OF_DATE'), value: 1 },
      { label: lang.t('constant.seaExportConstants.CONTRACT_STATE_SIGNED'), value: 2 }
    ],
    // sop推送类型
    sopTypes: [
      { name: lang.t('constant.sopTypes.all'), value: '' }, // 0
      { name: lang.t('constant.sopTypes.sopSend'), value: 1 },
      { name: lang.t('constant.sopTypes.innerSend'), value: 2 },
      { name: lang.t('Sop.SopWarning'), value: 3 },
      { name: lang.t('CargoMsg.Cargo_DataServiceReminder'), value: 4 },
      { name: lang.t('SystemMaintenance.FileHistory'), value: 5 },
      { name: lang.t('SystemMaintenance.InvoicePush'), value: 6 }
    ],
    // 推送渠道
    pushingChannel: [
      { name: lang.t('constant.pushingChannel.all'), value: '' }, // -1
      { name: lang.t('constant.pushingChannel.email'), value: 0 },
      { name: lang.t('constant.pushingChannel.msg'), value: 1 }],
    // 推送结果
    pushResult: [
      { name: lang.t('constant.pushResult.all'), value: '' }, // -1
      { name: lang.t('constant.pushResult.success'), value: 1 },
      { name: lang.t('constant.pushResult.fail'), value: 0 }],
    // 业务类型
    lobSource: [
      { name: lang.t('constant.systemConstants.SE'), value: 'SE' },
      { name: lang.t('constant.systemConstants.SI'), value: 'SI' },
      { name: lang.t('constant.systemConstants.AE'), value: 'AE' },
      { name: lang.t('constant.systemConstants.AI'), value: 'AI' },
      { name: lang.t('constant.systemConstants.RE'), value: 'RE' },
      { name: lang.t('constant.systemConstants.RI'), value: 'RI' }
    ],
    // fba和业务类型
    allLobSource: [
      { name: lang.t('constant.systemConstants.SE'), value: 'SE' },
      { name: lang.t('constant.systemConstants.SI'), value: 'SI' },
      { name: lang.t('constant.systemConstants.AE'), value: 'AE' },
      { name: lang.t('constant.systemConstants.AI'), value: 'AI' },
      { name: lang.t('constant.systemConstants.RE'), value: 'RE' },
      { name: lang.t('constant.systemConstants.RI'), value: 'RI' },
      { name: lang.t('constant.systemConstants.FBASE'), value: 'FBASE' },
      { name: lang.t('constant.systemConstants.FBAAE'), value: 'FBAAE' },
      { name: lang.t('constant.systemConstants.FBARE'), value: 'FBARE' },
      { name: lang.t('constant.systemConstants.IE'), value: 'IE' }
    ],
    // fba业务类型
    fbaLobSource: [
      { name: lang.t('constant.systemConstants.FBASE'), value: 'FBASE' },
      { name: lang.t('constant.systemConstants.FBAAE'), value: 'FBAAE' },
      { name: lang.t('constant.systemConstants.FBARE'), value: 'FBARE' }
    ],
    // 提单类型
    billTypeSource: [
      { name: lang.t('constant.BillType.MBL'), value: 'MBL' },
      { name: lang.t('constant.BillType.HBL'), value: 'HBL' }
    ],
    nodeType: [ // 节点类型定义
      { name: lang.t('constant.nodeType.lodingPort'), value: 1 },
      { name: lang.t('constant.nodeType.transferPort'), value: 2 },
      { name: lang.t('constant.nodeType.destinationPort'), value: 3 },
      { name: lang.t('constant.nodeType.warehousing'), value: 4 },
      { name: lang.t('constant.nodeType.booking'), value: 5 },
      { name: lang.t('constant.nodeType.entrust'), value: 6 },
      { name: lang.t('constant.nodeType.container'), value: 7 },
      { name: lang.t('constant.nodeType.distribution'), value: 8 },
      { name: lang.t('constant.nodeType.supplement'), value: 9 }
    ],
    sop: [
      { name: lang.t('constant.sop.JOB_NO'), chineseName: '业务编号' },
      { name: lang.t('constant.sop.CUSTOMER_ID'), chineseName: '委托单位' },
      { name: lang.t('constant.sop.CUSTOMER_ID_CN'), chineseName: '委托单位(中文)' },
      { name: lang.t('constant.sop.CUSTOMER_ID_US'), chineseName: '委托单位(英文)' },
      { name: lang.t('constant.sop.CARRIER_CN'), chineseName: '船公司(中文)' },
      { name: lang.t('constant.sop.CARRIER_US'), chineseName: '船公司(英文)' },
      { name: lang.t('constant.sop.CARRIER_CODE'), chineseName: '船公司(代码)' },
      { name: lang.t('constant.sop.CARRIER_SHORT_NAME'), chineseName: '船公司(简称)' },
      { name: lang.t('constant.sop.DESTINATION_AGENT'), chineseName: '目的港代理' },
      { name: lang.t('constant.sop.DESIGNATION_AGENT'), chineseName: '指定货代理' },
      { name: lang.t('constant.sop.LOADING_PORT_CODE'), chineseName: '起运港' },
      { name: lang.t('constant.sop.DESTINATION_PORT_CODE'), chineseName: '目的港' },
      { name: lang.t('constant.sop.VESSEL'), chineseName: '船名' },
      { name: lang.t('constant.sop.VOYAGE'), chineseName: '航次' },
      { name: lang.t('constant.sop.NameOfFeederBarge'), chineseName: '支线驳船船名' },
      { name: lang.t('constant.sop.BranchBargeVoyages'), chineseName: '支线驳船航次' },
      { name: lang.t('constant.sop.WAREHOUSE_NO'), chineseName: '进仓编号' },
      { name: lang.t('constant.sop.SO_NO'), chineseName: 'S/O NO' },
      { name: lang.t('constant.sop.MBL'), chineseName: 'MB/L NO' },
      { name: lang.t('constant.sop.HBL_NO'), chineseName: 'HB/L NO' },
      { name: lang.t('constant.sop.ETD'), chineseName: 'ETD' },
      { name: lang.t('constant.sop.ETA'), chineseName: 'ETA' },
      { name: lang.t('constant.sop.ATD'), chineseName: 'ATD' },
      { name: lang.t('constant.sop.ATA'), chineseName: 'ATA' },
      { name: lang.t('constant.sop.CONSIGNEE_CODE'), chineseName: '收货人' },
      { name: lang.t('constant.sop.CUSTOMER_REF_NO'), chineseName: '业务参考号' },
      { name: lang.t('constant.sop.USER_DEFINED_FIELD1'), chineseName: '自定义字段1' },
      { name: lang.t('constant.sop.USER_DEFINED_FIELD2'), chineseName: '自定义字段2' },
      { name: lang.t('constant.sop.USER_DEFINED_FIELD3'), chineseName: '自定义字段3' },
      { name: lang.t('constant.sop.ESTIMATED_SHIPPING_DATE'), chineseName: '预计船期' },
      { name: lang.t('constant.sop.DELIVER_DATE'), chineseName: '提货日期' },
      { name: lang.t('constant.sop.ARRIVE_STORAGE_DATE'), chineseName: '到库日期' },
      { name: lang.t('constant.sop.TRANS_DATE'), chineseName: '换单日期' },
      { name: lang.t('constant.sop.CUSTOMER_REF_NO2'), chineseName: '客户参考号' },
      { name: lang.t('constant.sop.LOADING_PORT_CODE2'), chineseName: '装货港' },
      { name: lang.t('constant.sop.CARRIER_ID'), chineseName: '航空公司' },
      { name: lang.t('constant.sop.CARRIER_ID_CN'), chineseName: '航空公司(中文)' },
      { name: lang.t('constant.sop.CARRIER_ID_US'), chineseName: '航空公司(英文)' },
      { name: lang.t('constant.sop.VOYAGE_FLIGHT'), chineseName: '航班' },
      { name: lang.t('constant.sop.ETD2'), chineseName: '开航日期' },
      { name: lang.t('constant.sop.ETA2'), chineseName: '到港日期' },
      { name: lang.t('constant.sop.WAREHOUSE_NO2'), chineseName: '进仓编号' },
      { name: lang.t('constant.sop.QUANTITY'), chineseName: '件数(入仓)' },
      { name: lang.t('constant.sop.WEIGHT'), chineseName: '毛重(入仓)' },
      { name: lang.t('constant.sop.VOLUME'), chineseName: '体积(入仓)' },
      { name: lang.t('constant.sop.DOWNLOAD_URL'), chineseName: '预录单下载链接' },
      { name: lang.t('constant.sop.MBL2'), chineseName: 'MAWB NO' },
      { name: lang.t('constant.sop.HAWB'), chineseName: 'HAWB NO' },
      { name: lang.t('constant.sop.DISCHARGING_PORT'), chineseName: '卸货港' },
      { name: lang.t('constant.sop.WAREHOUSE_DATA'), chineseName: '进仓数据' },
      { name: lang.t('constant.sop.STATUS_UPDATE_TIME'), chineseName: '状态变更时间' }
    ],
    templateRuleName: [ // 文件类型管理-模板规则定义
      { name: lang.t('constant.templateRuleName.CUSTOMER_CN_NAME'), value: '1' },
      { name: lang.t('constant.templateRuleName.CUSTOMER_SHORT_NAME'), value: '2' },
      { name: lang.t('constant.templateRuleName.SETTLEMENT_CN_NAME'), value: '3' },
      { name: lang.t('constant.templateRuleName.SETTLEMENT_SHORT_NAME'), value: '4' },
      { name: lang.t('constant.templateRuleName.BOOKING_AGENT_CN_NAME'), value: '5' },
      { name: lang.t('constant.templateRuleName.BOOKING_AGENT_SHORT_NAME'), value: '6' },
      { name: lang.t('constant.templateRuleName.LOB_NO'), value: '7' },
      { name: lang.t('constant.templateRuleName.MBL_NO'), value: '8' },
      { name: lang.t('constant.templateRuleName.HBL_NO'), value: '9' },
      { name: lang.t('constant.templateRuleName.REF_NO'), value: '10' },
      { name: lang.t('constant.templateRuleName.BILL_NO'), value: '11' },
      { name: lang.t('constant.templateRuleName.BILL_PAYMENT_NO'), value: '12' },
      { name: lang.t('constant.templateRuleName.WAREHOUSE_NO'), value: '13' },
      { name: lang.t('constant.templateRuleName.CARRIER_CN_NAME'), value: '14' },
      { name: lang.t('constant.templateRuleName.CARRIER_SHORT_NAME'), value: '15' },
      { name: lang.t('constant.templateRuleName.ETD'), value: '16' },
      { name: lang.t('constant.templateRuleName.DESTINATION_PORT_CODE'), value: '17' },
      { name: lang.t('constant.templateRuleName.DESTINATION_PORT_CODE_CODE'), value: '18' },
      { name: lang.t('constant.templateRuleName.PONO'), value: '19' },
      { name: lang.t('constant.templateRuleName.CUSTOMER_REF_NO'), value: '20' },
      { name: lang.t('constant.templateRuleName.PLATE_NUMBER_DOOR'), value: '21' },
      { name: lang.t('constant.templateRuleName.PLATE_NUMBER_DEST'), value: '22' },
      { name: lang.t('CargoMsg.Cargo_ContainerNo'), value: '23' },
      { name: 'HAWB No', value: '24' },
      { name: 'MAWB No', value: '25' },
      { name: lang.t('SystemMaintenance.TemplateName'), value: '26' },
      { name: lang.t('SystemMaintenance.VirtualBillHBLNO'), value: '27' },
      { name: lang.t('SystemMaintenance.TemplateRemarks'), value: '28' }
    ],
    // 生成单据设置-生成单据条件
    genDocCondition: [
      { name: lang.t('constant.genDocCondition.FormalHbl'), value: 1 }
    ],
    // 操作按钮设置-按钮名称
    buttonName: [
      { name: lang.t('constant.buttonName.FormalHbl'), value: 1 }
    ]

  }
  return key ? data[key] || [] : data
}

export default {
  ...constantI18n(lang)
}

